import React, { memo, useCallback } from 'react';

import { ButtonBase, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { chipLabelStyles, chipOwnStyles, chipStyles } from '../../TeamChatReactions.styles';

const ReactionChip = memo(({ emoji, count, isOwn, onToggle = null }) => {
  const onClick = useCallback(() => {
    onToggle?.(emoji, isOwn);
  }, [emoji, isOwn, onToggle]);

  return (
    <ButtonBase disabled={!onToggle} sx={isOwn ? chipOwnStyles : chipStyles} onClick={onClick}>
      <Typography sx={chipLabelStyles} variant="regular12">
        {`${emoji} ${count}`}
      </Typography>
    </ButtonBase>
  );
});
ReactionChip.propTypes = {
  count: PropTypes.number.isRequired,
  emoji: PropTypes.string.isRequired,
  isOwn: PropTypes.bool.isRequired,
  onToggle: PropTypes.func,
};

export default ReactionChip;
